import { FETCH_DASHBOARD_REQUEST, FETCH_DASHBOARD_SUCCESS, FETCH_DASHBOARD_FAILURE } from "../types"

const initialState = {
    data: {
        applications: {
            total: 0,
            pending: 0,
            inReview: 0,
            admitted: 0,
            newThisMonth: 0
        },
        students: {
            total: 0,
            active: 0,
            probation: 0,
            suspended: 0,
            newThisMonth: 0
        },
        generatedAt: null
    },
    loading: false,
    error: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
    switch(action.type){
        case FETCH_DASHBOARD_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }
        case FETCH_DASHBOARD_SUCCESS:
            return{
                ...state,
                loading: false,
                error: null,
                data: action.payload,
            }
        case FETCH_DASHBOARD_FAILURE:
            return{
                ...state,
                loading: false,
                error: action.payload 
            }
        default:
            return state
    }
}
